import React from "react";

import { css, cx } from "@emotion/css";
import Drawer from "@mui/material/Drawer";

import { useStyles } from "@/hooks/useStyles.ts";
import { AtomProps, StyleClasses } from "@/uiKit/atoms/utils/AtomTypes.ts";

const SIDE_SHEET_MAX_WIDTH_PX = 600;

type BaseSideSheetProps = {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
};

export type SideSheetProps = AtomProps<BaseSideSheetProps, StyleClasses<"drawer" | "paper" | "container">>;

export const SideSheet: React.FC<SideSheetProps> = ({ id, open, onClose, children, classes, className }) => {
  const styles = useStyles(makeStyles);
  return (
    <Drawer
      id={id}
      open={open}
      anchor="right"
      onClose={onClose}
      onClick={e => e.stopPropagation()}
      className={cx(className, classes?.drawer)}
      classes={{ paper: cx(styles.paper, classes?.paper) }}
    >
      {open && <div className={cx(styles.container, classes?.container)}>{children}</div>}
    </Drawer>
  );
};

const makeStyles = () => ({
  paper: css({
    overflowX: "clip",
    boxShadow: "none",
    "&:hover": {
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
    },
    "&:focus": {
      boxShadow: "none",
    },
  }),
  container: css({
    display: "flex",
    flexDirection: "column",
    width: `min(${SIDE_SHEET_MAX_WIDTH_PX}px, 100vw)`,
    height: "100%",
    overflow: "clip",
  }),
});
